<template>
    <span class="index-counter" :class="colorClass">{{padZeroes(index + 1)}} of {{padZeroes(count)}}</span>
</template>

<script>

export default {
  name: "indexCounter",
  props: {
    index: Number,
    count: Number
  },
  methods: {
    padZeroes(number) {
      if (number > 9 || number % 1 != 0) return number;
      return "0" + number;
    }
  }
}
</script>
